import { useAssistantSession } from './useAssistantSession.js';

// Module-level singleton so the legacy useTavusConversation() and
// useGiftSearch() adapters below share state. The prod GovavaAIGift.vue
// imports each separately and expects their refs to stay in sync.
let instance = null;
export function getSharedAssistantSession() {
  if (!instance) instance = useAssistantSession();
  return instance;
}
